import React from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
export function SitemapPage() {
  const {
    lang
  } = useTranslation();
  return <Layout data-id="element-2582">
      <section className="py-16 bg-white" data-id="element-2583">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2584">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-2585">
            Dentico Clinic Sitemap
          </h1>
          <p className="text-lg text-gray-600 mb-12" data-id="element-2586">
            Welcome to Dentico Clinic, Private Dental Clinic in Angel, London
            EC1V.
          </p>

          <div className="space-y-10" data-id="element-2587">
            {/* Main Pages */}
            <div data-id="element-2588">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2589">
                Main Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-2590">
                <li data-id="element-2591">
                  <Link to={`/${lang}`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2592">
                    Home – Private Dentist in Angel, London
                  </Link>
                </li>
                <li data-id="element-2593">
                  <Link to={`/${lang}/about`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2594">
                    About Us – Meet Our Dental Team
                  </Link>
                </li>
                <li data-id="element-2595">
                  <Link to={`/${lang}/contact`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2596">
                    Contact – Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Language Versions */}
            <div data-id="element-2597">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2598">
                Language Versions
              </h2>
              <ul className="space-y-2.5" data-id="element-2599">
                <li data-id="element-2600">
                  <Link to="/en" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2601">
                    🇬🇧 English Version
                  </Link>
                </li>
                <li data-id="element-2602">
                  <Link to="/ua" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2603">
                    🇺🇦 Ukrainian Version
                  </Link>
                </li>
                <li data-id="element-2604">
                  <Link to="/ru" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2605">
                    🇷🇺 Russian Version
                  </Link>
                </li>
              </ul>
            </div>

            {/* Dental Services */}
            <div data-id="element-2606">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2607">
                Dental Services
              </h2>
              <ul className="space-y-2.5" data-id="element-2608">
                <li data-id="element-2609">
                  <Link to={`/${lang}/services`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2610">
                    All Services
                  </Link>
                </li>
                <li data-id="element-2611">
                  <Link to={`/${lang}/services/checkup`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2612">
                    Dental Check-ups
                  </Link>
                </li>
                <li data-id="element-2613">
                  <Link to={`/${lang}/services/hygiene`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2614">
                    Professional Hygiene & Airflow
                  </Link>
                </li>
                <li data-id="element-2615">
                  <Link to={`/${lang}/services/fillings`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2616">
                    White Fillings
                  </Link>
                </li>
                <li data-id="element-2617">
                  <Link to={`/${lang}/services/root-canal`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2618">
                    Root Canal Treatment
                  </Link>
                </li>
                <li data-id="element-2619">
                  <Link to={`/${lang}/services/crowns`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2620">
                    Crowns & Bridges
                  </Link>
                </li>
                <li data-id="element-2621">
                  <Link to={`/${lang}/services/smile-makeover`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2622">
                    Veneers & Smile Makeover
                  </Link>
                </li>
                <li data-id="element-2623">
                  <Link to={`/${lang}/services/extraction`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2624">
                    Tooth Extraction
                  </Link>
                </li>
                <li data-id="element-2625">
                  <Link to={`/${lang}/services/whitening`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2626">
                    Teeth Whitening
                  </Link>
                </li>
                <li data-id="element-2627">
                  <Link to={`/${lang}/services/cosmetic`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2628">
                    Cosmetic Treatments
                  </Link>
                </li>
              </ul>
            </div>

            {/* Specialist Pages (UA) */}
            <div data-id="element-2629">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2630">
                Specialist Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-2631">
                <li data-id="element-2632">
                  <Link to="/ua/ukrainskyi-stomatolog-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2633">
                    🇺🇦 Ukrainian Dentist in London
                  </Link>
                </li>
                <li data-id="element-2634">
                  <Link to="/ua/implanty-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2635">
                    Dental Implants in London (UA)
                  </Link>
                </li>
                <li data-id="element-2636">
                  <Link to="/ua/veneers-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2637">
                    Veneers in London (UA)
                  </Link>
                </li>
                <li data-id="element-2638">
                  <Link to="/ua/root-canal-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2639">
                    Root Canal in London (UA)
                  </Link>
                </li>
                <li data-id="element-2640">
                  <Link to="/ua/emergency-dentist-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2641">
                    Emergency Dentist in Angel (UA)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Blog */}
            <div data-id="element-2642">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2643">
                Blog
              </h2>
              <ul className="space-y-2.5" data-id="element-2644">
                <li data-id="element-2645">
                  <Link to={`/${lang}/blog`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2646">
                    All Articles
                  </Link>
                </li>
                <li data-id="element-2647">
                  <Link to={`/${lang}/blog/skilky-koshtuyut-implanty-london`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2648">
                    Скільки коштують імпланти в Лондоні?
                  </Link>
                </li>
                <li data-id="element-2649">
                  <Link to={`/${lang}/blog/nhs-vs-private-dentistry-uk`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2650">
                    NHS vs Private Dentistry in the UK
                  </Link>
                </li>
                <li data-id="element-2651">
                  <Link to={`/${lang}/blog/likuvannya-zubiv-uk-bez-strakhovky`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2652">
                    Лікування зубів у UK без страховки
                  </Link>
                </li>
                <li data-id="element-2653">
                  <Link to={`/${lang}/blog/zubnyi-bil-london-shcho-robyty`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2654">
                    Зубний біль у Лондоні — що робити?
                  </Link>
                </li>
                <li data-id="element-2655">
                  <Link to={`/${lang}/blog/viniry-london-shcho-potribno-znaty`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2656">
                    Вініри в Лондоні — що потрібно знати
                  </Link>
                </li>
                <li data-id="element-2657">
                  <Link to={`/${lang}/blog/yak-obraty-stomatologa-angel`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2658">
                    Як обрати стоматолога в Angel
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div data-id="element-2659">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2660">
                Pricing
              </h2>
              <ul className="space-y-2.5" data-id="element-2661">
                <li data-id="element-2662">
                  <Link to={`/${lang}/prices`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2663">
                    Dental Fees – Transparent Private Prices
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-2664">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-2665">
                Legal
              </h2>
              <ul className="space-y-2.5" data-id="element-2666">
                <li data-id="element-2667">
                  <Link to={`/${lang}/privacy-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2668">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-2669">
                  <Link to={`/${lang}/cookie-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2670">
                    Cookie Policy
                  </Link>
                </li>
                <li data-id="element-2671">
                  <Link to={`/${lang}/patient-privacy-notice`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-2672">
                    Patient Privacy Notice
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-2673">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-gray-600" data-id="element-2674">
              <div className="flex items-center gap-2" data-id="element-2675">
                <MapPin className="w-4 h-4 text-teal-600" data-id="element-2676" />
                <span data-id="element-2677">
                  Dentico Clinic · 360–364 City Road · London EC1V 2PY
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-2678">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-2679">
                <Button size="sm" className="gap-2" data-id="element-2680">
                  <Calendar className="w-4 h-4" data-id="element-2681" />
                  Book Online
                </Button>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-2682">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-2683">
                  <MessageCircle className="w-4 h-4 text-green-600" data-id="element-2684" />
                  WhatsApp
                </Button>
              </a>
              <a href="tel:+447345197820" data-id="element-2685">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-2686">
                  <Phone className="w-4 h-4" data-id="element-2687" />
                  Request a Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}